<template>
  <div class="app-wrapper">
    <Spinner v-if="isLoading" />
    <Header :fixed="true" />
    <router-view :data="allData"/>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "./components/Footer.vue";
import Spinner from "./components/Spinner.vue";
// import pageElementsData from "./json/pageElements.json";
// import collectionsData from "./json/collections.json";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Spinner,
  },
  data() {
    return {
      allData: {
        english: {},
        french: {},
        japanese: {},
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getData();

    //check for start language and redirect if present
    const startlang = document.querySelector('body').getAttribute('data-startlang');

    if (startlang !== undefined && startlang !== null && startlang !== '') {
      this.$router.push(startlang)
    }
  },
  methods: {
    getData() {
      this.isLoading = true;
      
      // load from collections.js file hosted on AWS
      let collections = collectionsData;

      //remove any collections we want to exclude
      //data attribute on body, comma seperated list
      let excludedCollections = document.querySelector('body').getAttribute('data-exclude');

      if (excludedCollections !== null) {
        excludedCollections = document.querySelector('body').getAttribute('data-exclude').split(',');

        collections = collections.filter(function(e) {
          return excludedCollections.indexOf(e.company) == -1;
        });
      }

      this.allData.english = {
        collections: collections,
        bannerVideo: pageElementsData[0].english,
        bannerTitle: pageElementsData[1].english,
        bannerButton: pageElementsData[2].english,
        instruction: pageElementsData[3].english,
        collectionButton: pageElementsData[4].english,
        contact: {
          text: pageElementsData[5].english,
          email: pageElementsData[6].english,
        },
        showreel: pageElementsData[7].english,
      }
    this.allData.french = {
        collections: collections,
        bannerVideo: pageElementsData[0].french,
        bannerTitle: pageElementsData[1].french,
        bannerButton: pageElementsData[2].french,
        instruction: pageElementsData[3].french,
        collectionButton: pageElementsData[4].french,
        contact: {
          text: pageElementsData[5].french,
          email: pageElementsData[6].french,
        },
        showreel: pageElementsData[7].french,
      }
      this.allData.japanese = {
        collections: collections,
        bannerVideo: pageElementsData[0].japanese,
        bannerTitle: pageElementsData[1].japanese,
        bannerButton: pageElementsData[2].japanese,
        instruction: pageElementsData[3].japanese,
        collectionButton: pageElementsData[4].japanese,
        contact: {
          text: pageElementsData[5].japanese,
          email: pageElementsData[6].japanese,
        },
        showreel: pageElementsData[7].japanese,
      }

      this.isLoading = false;
    },
  }
};
</script>

<style lang="scss">
</style>
